import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  tableBody: {
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gap: theme.spacing(1.5),
    },
  },

  tableRow: {
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridTemplateColumns: '1fr 0.6fr 0.6fr 1fr',
    },
  },

  cell: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
    },

    '&:not(:first-of-type):not(:last-of-type):not(:nth-last-of-type(2))': {
      [theme.breakpoints.down('md')]: {
        borderBottom: `2px solid ${alpha(theme.palette.text.primary, 0.05)}`,
        paddingBottom: theme.spacing(2),
      },
    },
  },
}));
